import { fetchWrapRPC } from '../services/api';
import { defaultBasePath } from './constants';
import { ClientService_GetClient, ClientService_ListClients } from './gen/ai/h2o/cloud/discovery/v1/client_api_pb';
import { EnvironmentService_GetEnvironment } from './gen/ai/h2o/cloud/discovery/v1/environment_api_pb';
import { ServiceService_GetService, ServiceService_ListServices } from './gen/ai/h2o/cloud/discovery/v1/service_api_pb';
import { RequestConfig } from './gen/runtime';

const requestConfig: RequestConfig = {
  basePath: `${
    process.env.REACT_APP_API_PATH || (process.env.REACT_APP_USE_MOCK_SERVER ? defaultBasePath : window.origin)
  }/.ai.h2o.cloud.discovery`,
};

export const getEnvironment = fetchWrapRPC(EnvironmentService_GetEnvironment, requestConfig);

export const getClient = fetchWrapRPC(ClientService_GetClient, requestConfig);

export const listClients = fetchWrapRPC(ClientService_ListClients, requestConfig);

export const getService = fetchWrapRPC(ServiceService_GetService, requestConfig);

export const listServices = fetchWrapRPC(ServiceService_ListServices, requestConfig);
